import React, { useState, useEffect, useCallback } from 'react';
import { scanApi } from '../utils/scanApi';
import { brand } from '../theme/brandTheme';

const BRAND = {
  primary: "#6BCE8B",
  primaryDark: "#4EAD6E",
  primaryLight: "#E8F8EE",

  secondary: "#035EA5",
  secondaryLight: "#E6F0F9",

  white: "#FFFFFF",

  gray50: "#F8FAFC",
  gray100: "#F1F5F9",
  gray200: "#E2E8F0",
  gray300: "#CBD5E1",
  gray400: "#94A3B8",
  gray500: "#64748B",
  gray600: "#475569",
  gray900: "#0F172A",
};

const FONT = "'Inter', sans-serif";
// ─── Stepper bar styles ───────────────────────────────────────────
const S = {
  wrapper: {
  background: BRAND.white,
  border: `1px solid ${BRAND.gray200}`,
  borderRadius: "10px",
  boxShadow: "0 1px 2px rgba(0,0,0,0.04)",
  marginBottom: 24,
  overflow: "hidden",
},
  // accentBar: {
  //   position: 'absolute',
  //   top: 0, left: 0, right: 0,
  //   height: 3,
  //   background: `linear-gradient(90deg, ${brand.colors.secondary}, ${brand.colors.primary})`,
  // },
 cardHeader: {
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
  padding: "14px 20px",
  borderBottom: `1px solid ${BRAND.gray200}`,
},

cardTitle: {
  fontSize: 14,
  fontWeight: 700,
  color: BRAND.gray900,
  fontFamily: FONT,
},
  // ── Stepper ──
 stepperRow: {
  display: "flex",
  alignItems: "center",
  padding: "24px 40px",
  borderBottom: `1px solid ${BRAND.gray200}`,
  background: BRAND.gray50,
},
  stepItem: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    flex: 1,
    position: 'relative',
    zIndex: 1,
  },
 stepCircleActive: {
  width: 42,
  height: 42,
  borderRadius: "50%",
  background: BRAND.secondary,
  color: "#fff",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  fontSize: 16,
  fontWeight: 700,
  fontFamily: FONT,
  marginBottom: 8,
  border: `2px solid ${BRAND.secondary}`,
  boxShadow: "none",
},

stepCircleDone: {
  width: 42,
  height: 42,
  borderRadius: "50%",
  background: BRAND.primary,
  color: "#fff",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  fontSize: 18,
  fontWeight: 700,
  fontFamily: FONT,
  marginBottom: 8,
  border: `2px solid ${BRAND.primary}`,
},

stepCircleInactive: {
  width: 42,
  height: 42,
  borderRadius: "50%",
  background: "#fff",
  color: BRAND.gray500,
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  fontSize: 16,
  fontWeight: 700,
  fontFamily: FONT,
  marginBottom: 8,
  border: `1px solid ${BRAND.gray300}`,
},
 stepLabel: (active, done) => ({
  fontSize: 12,
  fontWeight: active || done ? 600 : 400,
  color: active ? BRAND.secondary : done ? BRAND.primary : BRAND.gray500,
  fontFamily: FONT,
  textAlign: "center",
}),

stepConnector: (done) => ({
  flex: 1,
  height: 2,
  background: done ? BRAND.secondary : BRAND.gray200,
  marginBottom: 28,
  zIndex: 0,
}),

  // ── Body ──
  body: {
  padding: "24px 28px",
},

label: {
  fontSize: 11,
  fontWeight: 700,
  color: BRAND.gray500,
  textTransform: "uppercase",
  letterSpacing: 0.8,
  marginBottom: 10,
  fontFamily: FONT,
},
 inputRow: {
  display: "flex",
  gap: 12,
  marginBottom: 8,
  flexWrap: "wrap",
},

input: {
  flex: 1,
  minWidth: 200,
  padding: "10px 14px",
  background: "#fff",
  border: `1px solid ${BRAND.gray200}`,
  borderRadius: "8px",
  color: BRAND.gray900,
  fontSize: 13,
  fontFamily: FONT,
  outline: "none",
},
// ✅ ADD THESE 3 NEW STYLES right after the input style above:
inputGroup: {
  flex: 1,
  minWidth: 200,
  display: "flex",
  border: `1px solid ${BRAND.gray200}`,
  borderRadius: "8px",
  overflow: "hidden",
  background: "#fff",
},

protocolSelect: {
  padding: "10px 10px 10px 12px",
  background: BRAND.gray50,
  border: "none",
  borderRight: `1px solid ${BRAND.gray200}`,
  color: BRAND.gray600,
  fontSize: 13,
  fontFamily: FONT,
  fontWeight: 600,
  cursor: "pointer",
  outline: "none",
  appearance: "none",
  WebkitAppearance: "none",
  MozAppearance: "none",
  paddingRight: 28,
  backgroundImage: `url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12' viewBox='0 0 24 24' fill='none' stroke='%2364748B' stroke-width='2.5' stroke-linecap='round' stroke-linejoin='round'%3E%3Cpolyline points='6 9 12 15 18 9'/%3E%3C/svg%3E")`,
  backgroundRepeat: "no-repeat",
  backgroundPosition: "right 8px center",
  minWidth: 90,
},

inputInGroup: {
  flex: 1,
  padding: "10px 14px",
  background: "#fff",
  border: "none",
  color: BRAND.gray900,
  fontSize: 13,
  fontFamily: FONT,
  outline: "none",
},
 btnPrimary: {
  padding: "10px 18px",
  background: BRAND.secondary,
  color: "#fff",
  border: "none",
  borderRadius: "8px",
  fontSize: 13,
  fontWeight: 600,
  cursor: "pointer",
  fontFamily: FONT,
  whiteSpace: "nowrap",
  display: "inline-flex",
  alignItems: "center",
  gap: 8,
},

btnOutline: {
  padding: "10px 16px",
  background: "#fff",
  color: BRAND.gray600,
  border: `1px solid ${BRAND.gray200}`,
  borderRadius: "8px",
  fontSize: 13,
  fontWeight: 600,
  cursor: "pointer",
  fontFamily: FONT,
},

btnDisabled: {
  opacity: 0.5,
  cursor: "not-allowed",
  background: BRAND.gray100,
  color: BRAND.gray400,
  border: `1px solid ${BRAND.gray200}`,
  padding: "10px 18px",
  borderRadius: "8px",
  fontSize: 13,
  fontWeight: 600,
  fontFamily: FONT,
},
  spinner: {
    display: 'inline-block',
    width: 14, height: 14,
    border: `2px solid rgba(255,255,255,0.3)`,
    borderTopColor: '#fff',
    borderRadius: '50%',
    animation: 'spin 0.8s linear infinite',
  },

  // ── DNS Box ──
  dnsBox: {
  background: BRAND.gray50,
  border: `1px solid ${BRAND.gray200}`,
  borderRadius: "10px",
  padding: "20px 24px",
  marginBottom: 20,
  overflow: "hidden",
},
  // dnsAccent: {
  //   position: 'absolute',
  //   top: 0, left: 0, right: 0,
  //   height: 3,
  //   background: `linear-gradient(90deg, ${brand.colors.secondary}, ${brand.colors.primary})`,
  // },
  dnsGrid: {
    display: 'grid',
    gridTemplateColumns: '160px 160px',
    gap: '12px 32px',
    marginBottom: 16,
  },
  tokenRow: {
    display: 'flex',
    alignItems: 'center',
    gap: 10,
    marginTop: 4,
  },
 tokenBox: {
  fontFamily: "monospace",
  fontSize: 13,
  color: BRAND.secondary,
  background: "#fff",
  padding: "9px 14px",
  borderRadius: "8px",
  border: `1px solid ${BRAND.gray200}`,
  flex: 1,
  wordBreak: "break-all",
  cursor: "pointer",
},

copyBtn: {
  padding: "9px 16px",
  background: "#fff",
  border: `1px solid ${BRAND.gray200}`,
  borderRadius: "8px",
  fontSize: 12,
  fontWeight: 600,
  color: BRAND.gray600,
  cursor: "pointer",
  fontFamily: FONT,
  whiteSpace: "nowrap",
},
 // AFTER
stepsNote: {
  fontSize: 11,
  color: BRAND.gray500,
  lineHeight: 1.8,
  margin: "14px 0 18px",
  fontFamily: FONT,
  paddingLeft: 0,
  listStyle: "none",
},

stepsNoteItem: {
  display: "flex",
  alignItems: "flex-start",
  gap: 8,
  marginBottom: 6,
},

stepsBullet: {
  width: 18,
  height: 18,
  borderRadius: "50%",
  background: BRAND.secondaryLight,
  color: BRAND.secondary,
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  fontSize: 10,
  fontWeight: 700,
  flexShrink: 0,
  marginTop: 1,
},
  actionRow: {
    display: 'flex',
    gap: 12,
    alignItems: 'center',
  },

  // ── Step 3 locked panel ──
  lockedBox: {
    background: '#F5F5F5',
    border: `1px solid ${brand.colors.surfaceBorder}`,
    borderRadius: brand.radius.md,
    padding: '20px 24px',
  },
  lockedTitle: {
    fontSize: 13,
    fontWeight: 700,
    color: brand.colors.textMuted,
    marginBottom: 6,
    fontFamily: brand.font,
  },
  lockedNote: {
    fontSize: 13,
    color: '#AAAAAA',
    marginBottom: 14,
    fontFamily: brand.font,
  },
};

// ─── Stepper bar ──────────────────────────────────────────────────
const STEPS = ['Add Domain', 'Verify DNS', 'Launch Scan'];
const StepperBar = ({ current, maxStep, onStepClick }) => (
  <div style={S.stepperRow}>
    {STEPS.map((label, i) => {
      const stepNum    = i + 1;
      const isDone     = stepNum < current;
      const isActive   = stepNum === current;
      const isClickable = stepNum <= maxStep && stepNum !== current;
      const circle     = isDone
        ? <div style={S.stepCircleDone}>✓</div>
        : isActive
          ? <div style={S.stepCircleActive}>{stepNum}</div>
          : <div style={S.stepCircleInactive}>{stepNum}</div>;

      return (
        <React.Fragment key={label}>
          <div
            style={{ ...S.stepItem, cursor: isClickable ? 'pointer' : 'default' }}
            onClick={() => isClickable && onStepClick?.(stepNum)}
            title={isClickable ? `Go to ${label}` : undefined}
          >
            {circle}
            <span style={S.stepLabel(isActive, isDone)}>{label}</span>
          </div>
          {i < STEPS.length - 1 && (
            <div style={S.stepConnector(isDone || isActive)} />
          )}
        </React.Fragment>
      );
    })}
  </div>
);
// ═══════════════════════════════════════════════════════════════════
//  MAIN COMPONENT
// ═══════════════════════════════════════════════════════════════════
const DomainManagement = ({ organizationId, showToast, onDomainVerified, onGoToScan, dastStep, setDastStep,userData}) => {

  // const [currentStep, setCurrentStep]   = useState(1);
   const currentStep = dastStep;
  const setCurrentStep = setDastStep;
  const [domainInput, setDomainInput]   = useState('');
  const [registering, setRegistering]   = useState(false);
  const [protocol, setProtocol]         = useState('https://');
  const [verifying, setVerifying]       = useState(false);
  const [dnsConfig, setDnsConfig]       = useState(null);
  const [copied, setCopied]             = useState(false);
  const [hasVerifiedDomain, setHasVerifiedDomain] = useState(false);//check is verified

  // ── Auto-advance to step 3 if domains already verified ──────────
  useEffect(() => {
    const checkExisting = async () => {
      if (!organizationId) return;
      try {
        const data = await scanApi.listVerifiedDomains(organizationId);
        if (Array.isArray(data) && data.length > 0) {
           setDomainInput(data[0].domain);  
          setCurrentStep(3);
          setHasVerifiedDomain(true); 
          onDomainVerified?.();
        }
      } catch (_) {}
    };
    checkExisting();
  }, [organizationId]);

  // ── Step 1: Add domain ───────────────────────────────────────────
  const handleContinue = async () => {
    const raw = domainInput.trim();
    if (!raw) { showToast('Please enter a domain', 'error'); return; }

   const targetUrl = `${protocol}${raw}`;

    try {
      setRegistering(true);
      const result = await scanApi.initiateVerification(organizationId, targetUrl,userData);

      if (result.status === 'VERIFIED') {
        showToast(`${result.domain} is already verified ✅`, 'success');
        setCurrentStep(3);
         setHasVerifiedDomain(true); 
        onDomainVerified?.();
        return;
      }

      setDnsConfig({
        domain:     result.domain,
        recordType: result.dns?.recordType || 'TXT',
        host:       result.dns?.host || '@',
        value:      result.dns?.value || '',
      });
      setCurrentStep(2);
      showToast('Domain added! Now add the DNS TXT record below.', 'success');

    } catch (err) {
      showToast(err?.message || 'Failed to add domain', 'error');
    } finally {
      setRegistering(false);
    }
  };

  // ── Step 2: Verify DNS ───────────────────────────────────────────
  const handleVerify = async () => {
    if (!dnsConfig?.domain) return;
    try {
      setVerifying(true);
      const result = await scanApi.verifyDomain(organizationId, dnsConfig.domain,userData);

      if (result.status === 'VERIFIED') {
        showToast(`${dnsConfig.domain} verified successfully! ✅`, 'success');
        setCurrentStep(3);
         setHasVerifiedDomain(true); 
        setDnsConfig(null);
        onDomainVerified?.();
      } else {
        showToast('DNS record not found yet. Wait 2–5 minutes after adding, then try again.', 'error');
      }
    } catch (err) {
      showToast(err?.message || 'Verification failed', 'error');
    } finally {
      setVerifying(false);
    }
  };

  // ── Copy token ───────────────────────────────────────────────────
  const handleCopy = () => {
    if (!dnsConfig?.value) return;
    navigator.clipboard.writeText(dnsConfig.value).then(() => {
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    });
  };

  const handleKeyDown = (e) => {
    if (e.key === 'Enter') { e.preventDefault(); handleContinue(); }
  };

  // ═════════════════════════════════════════════════════════════════
  //  RENDER
  // ═════════════════════════════════════════════════════════════════
  return (
    <div style={S.wrapper}>
      {/* <div style={S.accentBar} /> */}

      {/* ── Card Header ── */}
      <div style={S.cardHeader}>
        <span style={S.cardTitle}>DAST — Domain Verification & Scanning</span>
      </div>

      {/* ── Stepper Bar ── */}
     <StepperBar
  current={currentStep}
  maxStep={hasVerifiedDomain ? 3 : currentStep}
  onStepClick={(step) => {
    if (step === 3 && hasVerifiedDomain) {
      setCurrentStep(3);
      setDnsConfig(null);
    } else if (step === 1 && currentStep > 1) {
      setCurrentStep(1);
      setDnsConfig(null);
      setDomainInput('');
    }
  }}
/>

      {/* ── Body ── */}
      <div style={S.body}>

        {/* ════ STEP 1 — Add Domain ════ */}
        {currentStep <= 2 && (
          <div style={{ marginBottom: 24 }}>
            <div style={S.label}>Step 1 — Add your target domain</div>
            <div style={S.inputRow}>
           
           <div
  style={{
    ...S.inputGroup,
    opacity: currentStep > 1 ? 0.6 : 1,
    pointerEvents: currentStep > 1 ? 'none' : 'auto',
  }}
>
  {/* Protocol Dropdown */}
  <select
    style={S.protocolSelect}
    value={protocol}
    onChange={(e) => setProtocol(e.target.value)}
    disabled={currentStep > 1}
    aria-label="Select protocol"
  >
    <option value="https://">https://</option>
    <option value="http://">http://</option>
  </select>

  {/* Domain Input */}
  <input
    style={S.inputInGroup}
    type="text"
    placeholder="example.com"
    value={domainInput}
    onChange={(e) => setDomainInput(e.target.value)}
    onKeyDown={handleKeyDown}
    disabled={currentStep > 1}
    onFocus={(e) => {
      e.target.closest('div').style.borderColor = `${BRAND.secondary}80`;
    }}
    onBlur={(e) => {
      e.target.closest('div').style.borderColor = BRAND.gray200;
    }}
  />
</div>
              {currentStep === 1 && (
                <button
                  style={{ ...S.btnPrimary, ...(registering ? { opacity: 0.6 } : {}) }}
                  onClick={handleContinue}
                  disabled={registering}
                >
                  {registering
                    ? <><span style={S.spinner} /> Adding...</>
                    : 'Continue'
                  }
                </button>
              )}
              {currentStep > 1 && (
                <button
                  style={{ ...S.btnOutline, fontSize: 12 }}
                  onClick={() => { setCurrentStep(1); setDnsConfig(null); setDomainInput(''); }}
                >
                   Change Domain
                </button>
              )}
            </div>
          </div>
        )}

        {/* ════ STEP 2 — DNS TXT Box ════ */}
        {currentStep === 2 && dnsConfig && (
          <div style={S.dnsBox}>
            {/* <div style={S.dnsAccent} /> */}

            <div style={{ ...S.label, marginBottom: 14 }}>
               Step 2 — Add This DNS TXT Record to Your Domain
            </div>

            <div style={S.dnsGrid}>
              <div>
                <div style={S.label}>Record Type</div>
                <div style={{ fontSize: 14, fontWeight: 700, color: brand.colors.text, fontFamily: brand.font }}>
                  {dnsConfig.recordType}
                </div>
              </div>
              <div>
                <div style={S.label}>Host / Name</div>
                <div style={{ fontSize: 14, fontWeight: 700, color: brand.colors.text, fontFamily: brand.font }}>
                  @
                </div>
              </div>
            </div>

            <div style={S.label}>Value (click to copy)</div>
            <div style={S.tokenRow}>
              <div style={S.tokenBox} onClick={handleCopy} title="Click to copy">
                {dnsConfig.value}
              </div>
              <button style={S.copyBtn} onClick={handleCopy}>
                {copied ? 'Copied!' : ' Copy'}
              </button>
            </div>

            {/* <p style={S.stepsNote}>
              <strong>Step 2</strong> — Add the record at your DNS provider (GoDaddy, Cloudflare, Route53, etc.).<br />
              <strong>Step 3</strong> — Wait <strong>2–5 minutes</strong> for DNS to propagate, then click <strong>Verify Now</strong>.
            </p> */}
         
<ul style={S.stepsNote}>
  <li style={S.stepsNoteItem}>
    <span style={S.stepsBullet}>2</span>
    <span>Add the record at your DNS provider (GoDaddy, Cloudflare, Route53, etc.).</span>
  </li>
  <li style={S.stepsNoteItem}>
    <span style={S.stepsBullet}>3</span>
    <span>Wait <strong>2–5 minutes</strong> for DNS to propagate, then click <strong>Verify Now</strong>.</span>
  </li>
</ul>

            <div style={S.actionRow}>
              <button
                style={{ ...S.btnPrimary, ...(verifying ? { opacity: 0.6 } : {}) }}
                onClick={handleVerify}
                disabled={verifying}
              >
                {verifying
                  ? <><span style={S.spinner} /> Verifying...</>
                  : 'Verify Now'
                }
              </button>
              <button
                style={S.btnOutline}
                onClick={() => setCurrentStep(1)}
              >
                Dismiss
              </button>
            </div>
          </div>
        )}

        {/* ════ STEP 3 — Launch Scan (locked until verified) ════ */}
        {/* {currentStep < 3 && (
          <div style={S.lockedBox}>
            <div style={S.lockedTitle}>🔒 Step 3 — Launch Scan</div>
            <div style={S.lockedNote}>Verify your domain first to unlock scanning.</div>
            <button style={S.btnDisabled} disabled>
              🚀 Launch Scan
            </button>
          </div>
        )} */}

        {/* ════ STEP 3 UNLOCKED — message + scroll hint ════ */}
        {/* {currentStep >= 3 && (
          <div style={{
            background: `linear-gradient(135deg, ${brand.colors.secondaryBg}, ${brand.colors.primaryBg})`,
            border: `1px solid ${brand.colors.primary}40`,
            borderRadius: brand.radius.md,
            padding: '18px 24px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            flexWrap: 'wrap',
            gap: 12,
          }}>
            <div>
              <div style={{ fontSize: 14, fontWeight: 700, color: brand.colors.text, fontFamily: brand.font, marginBottom: 4 }}>
                ✅ Domain Verified — Scanner Unlocked!
              </div>
              <div style={{ fontSize: 13, color: brand.colors.textMuted, fontFamily: brand.font }}>
                Select a verified domain below and launch your scan.
              </div>
            </div>
            <button
              style={S.btnPrimary}
              onClick={() => {
                document.getElementById('dast-scan-form')?.scrollIntoView({ behavior: 'smooth' });
                onGoToScan?.();
              }}
            >
              Go to Scanner ↓
            </button>
          </div>
        )} */}
        {/* ════ STEP 3 — Compact verified bar (replaces both input + banner) ════ */}
  {currentStep >= 3 && (
    <div style={{
  background: BRAND.primaryLight,
  border: `1px solid ${BRAND.primary}`,
  borderRadius: "10px",
  padding: "16px 20px",
  display: "flex",
  alignItems: "center",
  gap: 16,
  flexWrap: "wrap",
}}>
      <div style={{
  width: 36,
  height: 36,
  borderRadius: "50%",
  background: BRAND.primary,
  color: "#fff",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  fontSize: 18,
  fontWeight: 700,
  flexShrink: 0,
}}>✓</div>

      <div style={{ flex: 1, minWidth: 180 }}>
        <div style={{
  fontSize: 14,
  fontWeight: 700,
  color: BRAND.gray900,
  fontFamily: FONT,
}}>
          {domainInput || 'Domain Verified'}
        </div>
        <div style={{
  fontSize: 12,
  color: BRAND.gray500,
  fontFamily: FONT,
  marginTop: 2,
}}>
          Verified • Scanner unlocked
        </div>
      </div>

      <button
        style={{ ...S.btnOutline, fontSize: 12, padding: '8px 16px' }}
        onClick={() => { setCurrentStep(1); setDnsConfig(null); setDomainInput(''); }}
      >
         Change Domain
      </button>
    </div>
  )}



      </div>
    </div>
  );
};

export default DomainManagement;